import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';
import { ChartConfig } from './ChartConfig';



export class DoughnutChartConfig extends ChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {
    //console.log(categories);
    //console.log(data);

    const seriesRawData = data[0]?.data ?? [];

    const seriesData = seriesRawData.map((point: any, index: number) => {
      const value = typeof point === 'object' ? +point.value : +point;
      const name = categories[index] ?? `Item ${index + 1}`;
      const color = colors[index % colors.length]; // safely cycle through colors if not enough

      return {
        name,
        value,
        ...(typeof point === 'object' ? point : {}),
        itemStyle: {
          color,
        },
      };
    });
    //console.log(seriesRawData.reduce((sum, p) => sum + (typeof p === 'object' ? +p.value : p), 0));

    return {
      legend: {
        data: categories,
      },
      series: [
        {
          type: SeriesType.Doughnut,
          radius: ['38%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: seriesData,
        },
      ],
      graphic: [
        {
          type: 'text',
          left: 'center',
          top: '44%',
          style: {
            text: `${seriesRawData.reduce((sum, p) => sum + (typeof p === 'object' ? p.value1 ? +p.value1 : +p.value : p), 0)}`,
            textAlign: 'center',
            fill: 'var(--Primary-Default, #43474F)',
            fontFamily: 'Rubik',
            fontSize: 24,
            fontStyle: 'normal',
            fontWeight: 600,
          },
        },
        {
          type: 'text',
          left: 'center',
          top: '53%',
          style: {
            text: data[0].name ?? 'Value',
            textAlign: 'center',
            fill: 'var(--Primary-Light, #747884)',
            fontFamily: 'Rubik',
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 400,
          },
        },
      ],
      grid: {
        top: 30,
        bottom: 20,
        left: 30,
        right: 20,
        containLabel: true,
      },
    };
  }
}
